import BaseEntity from './BaseEntity';
export default class Report extends BaseEntity {
    constructor(data) {
        super();
        this.fixes = null;
        this.id = this.parseProperty(data, 'id');
        this.errorCount = this.parseProperty(data, 'errorCount');
        this.filePath = this.parseProperty(data, 'filePath');
        this.fixes = this.parseProperty(data, 'fixes');
        this.messages = this.parseProperty(data, 'messages');
        this.source = this.parseProperty(data, 'source');
        this.truncated = this.parseProperty(data, 'truncated');
        this.warningCount = this.parseProperty(data, 'warningCount');
    }
}
